// Display adapters for the authorized BenefitApplicationResponse used by PSE match review.
// These helpers do not select or copy a person, account, or household.

export function formatBenefitMoney(value: unknown): string {
  const amount = typeof value === "number"
    ? value
    : value && typeof value === "object" && "amount" in value
      ? value.amount
      : undefined
  if (typeof amount !== "number" || !Number.isFinite(amount)) return "Not available"
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(amount)
}

/** A previous file may pay multiple utilities: never imply its first payment is the PSE account. */
export function getBenefitAccountNumbers(benefit: { benefitGrants?: unknown } | null | undefined): string {
  if (!benefit || !Array.isArray(benefit.benefitGrants)) return "Not available"
  const accounts = new Set<string>()
  for (const grant of benefit.benefitGrants) {
    if (!grant || typeof grant !== "object") continue
    const payments = (grant as { serviceProviderPayments?: unknown }).serviceProviderPayments
    if (!Array.isArray(payments)) continue
    for (const payment of payments) {
      if (!payment || typeof payment !== "object") continue
      const account = (payment as { accountNumber?: unknown }).accountNumber
      if (typeof account === "string" && account.trim()) accounts.add(account.trim())
    }
  }
  return accounts.size ? [...accounts].sort().join(", ") : "Not available"
}

/** Do not display an old household while the newly selected file is loading (or has failed). */
export function currentBenefitData<T>(requestedId: string | undefined | null, loaded: { id: string; data: T } | null): T | null {
  return requestedId && loaded?.id === requestedId ? loaded.data : null
}
